import { useState, useRef, useEffect } from "react";
import _ from "lodash";
import { useDraggable } from "react-use-draggable-scroll";

import ProcessDesignerSchema from "./ProcessDesignerSchema";
import VariableDesigner from "../VariableDesigner/VariableDesigner";
import ConditionDesigner from "../ConditionDesigner/ConditionDesigner";
import ProcessDesignerTest from "./ProcessDesignerTest";
import ProcessDesignerCopy from "./ProcessDesignerCopy";
import AdminProcessPublish from "../AdminProcess/AdminProcessPublish";
import ProcessDesignerGroup from "./ProcessDesignerGroup";
import useMount from '../../hooks/useMount';
import useAccess from "../../hooks/useAccess";
import LoadingComponent from "../Commons/LoadingComponent";
import processApi from "../../api/processApi";
import variableApi from "../../api/variableApi";
import componentApi from "../../api/componentApi";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import ContextMenu from "../Commons/ContextMenu";
import ActionButton from "../Commons/ActionButton";
import ProcessDesignerNavigation from "./ProcessDesignerNavigation";
import ProcessDesignerCopyExternal from "./ProcessDesignerCopyExternal";
import ConditionDesignerSort from "../ConditionDesigner/ConditionDesignerSort";
import InitDesigner from "../Init/InitDesigner";

import { getLabel, getLanguage } from "../../tools/Dictionary";
import { getPathFromStep } from "../../tools/GeneralHelper";
import { FindOpenPosition } from "../../tools/DesignerHelper";

import { TbVariable, TbPlayerPlayFilled } from "react-icons/tb";
import { MdAdd, MdArrowDropDown, MdCode } from "react-icons/md";
import "./ProcessDesigner.css";


//const env_Process = process.env.NODE_ENV;

const ProcessDesigner = (props) =>
{


  //Props
  const IsDesktop = props.IsDesktop;
  const OnClose = props.OnClose;
  const Title = props.Title;
  const ProcessId = props.ProcessId;
  //const PublishProcessId = props.PublishProcessId;
  const ReadOnly = props.ReadOnly;
  const OnReloadData = props.OnReloadData;
  const IsExternalCopy = props.IsExternalCopy;
  const OnConfirmExternalCopy = props.OnConfirmExternalCopy;


  //Redux
  const Access = useAccess(["Ad_Trouble"]);

  //state
  const [loading, setLoading] = useState(false);
  const [process, setProcess] = useState({});
  const [component, setComponent] = useState([]);
  const [componentAction, setComponentAction] = useState({});
  const [step, setStep] = useState([]);
  const [group, setGroup] = useState([]);
  const [stepTemplate, setStepTemplate] = useState([]);
  const [tempId, setTempId] = useState(-1);
  const [displayStep, setDisplayStep] = useState({
    detail: false,
    id: 0
  });
  const [scrollPosition, setScrollPosition] = useState([]);
  const [flowchart, setFlowchart] = useState(true); 
  const [variable, setVariable] = useState([]);
  const [variableType, setVariableType] = useState([]);
  const [modalVariable, setModalVariable] = useState(false);
  const [modalCondition, setModalCondition] = useState({
    display: false,
    id: 0
  });
  const [modalConditionSort, setModalConditionSort] = useState({
    display: false,
    id: 0
  });
  const [modalInit, setModalInit] = useState(false);
  const [modalTest, setModalTest] = useState(false);
  const [change, setChange] = useState(false);
  const [newCounter, setNewCounter] = useState(1);
  const [copy, setCopy] = useState({
    enable: IsExternalCopy,
    modal: false,
    id: 0,
    data: [],
    external: false
  });

  const [externalCopy, setExternalCopy] = useState({
    enable: false,
    modal: false,
    id: 0,
    data: [],
    external: false
  });
  const [addStep, setAddStep] = useState({
    display: false,
    parentId: 0,
    parentPath: []
  });

  const [publish, setPublish] = useState(false);

  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [context, setContext] = useState({
    display: false,
    posX: 0,
    posY: 0,
    Option: []
  });
  const [modalGroup, setModalGroup] = useState({
    display: false,
    data: undefined,
    position: undefined
  });
  const [currentGroup, setCurrentGroup] = useState([
    {
      _id: undefined,
      title: getLabel("App", "Home")
    }
  ]);

  
  //Ref
  const parentContainer = useRef(null);
  const contextContainer = useRef(null);
  const { events } = useDraggable(parentContainer, {
    activeMouseButton: "Right",
    decayRate: 0
  });
  const rightClickPosition = useRef({
    x: 0,
    y: 0
  });

  //Variables
  const syscomponent = "ProcessDesigner";

  useMount(() => {
    loadData();
  });

  //if user close the detail and return to home, scroll at the last position
  useEffect(() => {


    if (scrollPosition && scrollPosition[currentGroup[currentGroup.length - 1].title] && !displayStep.detail){

      parentContainer.current.scrollTop = scrollPosition[currentGroup[currentGroup.length - 1].title].y;
      parentContainer.current.scrollLeft = scrollPosition[currentGroup[currentGroup.length - 1].title].x;

      // parentContainer.current.scrollTop = scrollPosition.y;
      // parentContainer.current.scrollLeft = scrollPosition.x;

    }else{
      parentContainer.current.scrollTop = 0;
      parentContainer.current.scrollLeft = 0;
    }


  }, [scrollPosition, displayStep.detail, currentGroup]);




  const loadData = async (_showLoading = true, _displayIndex = -1) =>
  {

    try
    {

      if (_showLoading)
      {
        setLoading(true);
      }

      const [processResponse, componentResponse, componentActionResponse, processStepTemplateResponse, variableResponse, variableTypeResponse] = await Promise.all([
        processApi.getProcessWithSteps({ _id: ProcessId }),
        //PublishProcessId ? processApi.getPublishProcessWithSteps({ _id: PublishProcessId })  : processApi.getProcessWithSteps({ _id: ProcessId }),
        componentApi.getComponents({ filter: "isActive is true", select: "_id,code,icon,data,description,isVariable,isAddable,isEditable", sort: "order asc" }),
        componentApi.getComponentActions({ filter: "isActive is true", select: "_id,code,label,order", sort: "order asc" }),
        processApi.getProcessesStepTemplates({ filter: "isActive is true", select: "_id,title,defaultTitle,label,component,navigationButton,prefill", sort: "order asc" }),
        variableApi.getVariables({ filter: "process eq " + ProcessId, select: `_id,name,description,process,variableType,variableTypeCode,variableTypeLabel,data,dataToDisplay,order,isParameter`, translate: getLanguage().code, sort: "order asc"}),
        variableApi.getVariableTypes({ filter: "isActive is true", select: `_id,code,label,isActive,order`, translate: getLanguage().code, sort: "order asc" }),
      ]);

      if (!processResponse.Success || !processResponse.Data.Process){
        let error = new Error()
        error.message = processResponse.Error && processResponse.Error.component ? getLabel(processResponse.Error.component, processResponse.Error.label) : undefined;

        throw error;
      }


      setProcess(processResponse.Data.Process);
      setStep(processResponse.Data.Step || []);
      setGroup(processResponse.Data.Group || []);

      //Update Navigation
      setCurrentGroup(updateCurrentGroup(processResponse.Data.Group, currentGroup[currentGroup.length - 1])); 


      if (_displayIndex > -1){

        setDisplayStep({
          detail: true,
          id: processResponse.Data.Step[_displayIndex]._id
        });

      }

      if (!componentResponse.Success)
      {
        let error = new Error()
        error.message = componentResponse.Error && componentResponse.Error.component ? getLabel(componentResponse.Error.component, componentResponse.Error.label) : undefined;

        throw error;
      }

      setComponent(componentResponse.Data);

      if (!componentActionResponse.Success)
      {
        let error = new Error()
        error.message = componentActionResponse.Error && componentActionResponse.Error.component ? getLabel(componentActionResponse.Error.component, componentActionResponse.Error.label) : undefined;

        throw error;
      }

      setComponentAction(componentActionResponse.Data);

      if (!processStepTemplateResponse.Success)
      {
        let error = new Error()
        error.message = processStepTemplateResponse.Error && processStepTemplateResponse.Error.component ? getLabel(processStepTemplateResponse.Error.component, processStepTemplateResponse.Error.label) : undefined;

        throw error;
      }

      setStepTemplate(processStepTemplateResponse.Data); 

      if (!variableResponse.Success)
      {
        let error = new Error()
        error.message = variableResponse.Error && variableResponse.Error.component ? getLabel(variableResponse.Error.component, variableResponse.Error.label) : undefined;

        throw error;
      }

      setVariable(variableResponse.Data);

      if (!variableTypeResponse.Success)
      {
        let error = new Error()
        error.message = variableTypeResponse.Error && variableTypeResponse.Error.component ? getLabel(variableTypeResponse.Error.component, variableTypeResponse.Error.label) : undefined;

        throw error;
      }

      setVariableType(variableTypeResponse.Data);
      

      setLoading(false);

    } catch (err)
    {

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: OnClose,
        Display: true
      });

      

    }

  };

  const updateCurrentGroup = (_group, _currentGroup) => {

    let maxLoop = 100;


    let newCurrentGroup = [];

    let foundGroup = _group.find(g => g.title == _currentGroup.title);

    if (foundGroup){

      newCurrentGroup.push(foundGroup);

      while (foundGroup && foundGroup.parentGroup && maxLoop > 0)
      {
        // eslint-disable-next-line no-loop-func
        foundGroup = _group.find(g => g._id == foundGroup.parentGroup);

        if (foundGroup)
          newCurrentGroup.push(foundGroup);
        else
          newCurrentGroup = [];

        maxLoop--;

      }

    }

    newCurrentGroup.push(
      {
        _id: undefined,
        title: getLabel("App", "Home")
      }
    );



    return newCurrentGroup.reverse();

  };

  const updateScrollPosition = (_position, _currentGroup = undefined) => {

    let toUpdateScrollPosition = _.cloneDeep(scrollPosition);

    let tempCurrentGroup = _currentGroup || currentGroup

    toUpdateScrollPosition[tempCurrentGroup[tempCurrentGroup.length - 1].title] = {
      x: _position.x,
      y: _position.y   
    };

    setScrollPosition(toUpdateScrollPosition);


  };

  const verifyGroupEntry = (_step, _group) => {


    let currentGroup = _.cloneDeep(_group);
    
    for (let j = 0; j < currentGroup.length; j++)
    {

      for (let i = 0; i < currentGroup[j].entry.length; i++)
      {

        let indexEntryInStep = _step.findIndex(s => s._id == currentGroup[j].entry[i].processStep &&  s.parentGroup == currentGroup[j]._id);

        if (indexEntryInStep > -1) {

          currentGroup[j].entry.splice(i, 1);
          i--;

        }
        
      //   if (!currentGroup[j].entry[i].isVerified)
      //   {
      //     currentGroup[j].entry.splice(i, 1);
      //     i--;
      //   }else{
      //     currentGroup[j].entry[i].isVerified = false;
      //   }
      // }
      }

    }

    _step.forEach(s => {

      let conditionGroupIndex = -1;
      let conditionStep = undefined;

      let needEntry = s.condition.some(c => {

        conditionStep = _step.find(s => s._id == c.processStep);

        if (!conditionStep || conditionStep.parentGroup == s.parentGroup) return false;

    
        conditionGroupIndex = currentGroup.findIndex(g => g._id == conditionStep.parentGroup);

        if (conditionGroupIndex > -1) return true;

        return false;

      });


      if (needEntry){

        let indexEntry = currentGroup[conditionGroupIndex].entry.findIndex(e => e.processStep == s._id);

        if (indexEntry == -1){


          let newPosition = FindOpenPosition(10, 50, 
            _step.filter(st => st.parentGroup == currentGroup[conditionGroupIndex]._id), 
            _group.filter(gr => gr.parentGroup == currentGroup[conditionGroupIndex]._id), 
            currentGroup[conditionGroupIndex].entry
          );

          currentGroup[conditionGroupIndex].entry.push({
            processStep: s._id,
            position: newPosition,
          });

        }

      }

    });


    return currentGroup;

  };

  const loadVariable = async (_showLoading = true) => {

    try
    {

      if (_showLoading)
      {
        setLoading(true);
      }

      const variableResponse = await variableApi.getVariables({ filter: "process eq " + ProcessId, select: `_id,name,description,process,variableType,variableTypeCode,variableTypeLabel,data,dataToDisplay,order`, translate: getLanguage().code, sort: "order asc" });

      if (!variableResponse.Success)
      {
        let error = new Error()
        error.message = variableResponse.Error && variableResponse.Error.component ? getLabel(variableResponse.Error.component, variableResponse.Error.label) : undefined;

        throw error;
      }

      setVariable(variableResponse.Data);   

      setLoading(false);
      
      return variableResponse.Data;

    }catch(err){


      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: OnClose,
        Display: true
      });

    }


  }

  const onClickVariableDesigner = () => {

    setModalVariable(modalVariable => !modalVariable);

  };

  const onClickTest = () => {


    if (step.length == 0) {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: getLabel("ProcessDesigner", "You have to create at least one step to test the process"),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      return;

    }

    setModalTest(true);


  };

  const onUpdateStep = (_step, _parentStep = undefined, _parentGroup = undefined) => {

    try{


      let updateStep = _.cloneDeep(step);
      let toUpdateGroup = _.cloneDeep(group);

      let indexUpdate = updateStep.findIndex(s => s._id === _step._id);

      if (indexUpdate > -1){

        updateStep[indexUpdate] = _step;

      }else{

        _step.newCounter = newCounter + 1;
        updateStep.push(_step);
        indexUpdate = [updateStep.length - 1];
      }


      if (_parentStep){

        let indexCondition = updateStep.findIndex(s => s._id == _parentStep);

        // eslint-disable-next-line array-callback-return
        updateStep[indexCondition].condition.sort((a, b) =>
        {
          if (a.order >= b.order) return 1;
          if (a.order < b.order) return -1;
        });

        let tempOrder = 10;

        updateStep[indexCondition].condition.forEach(c =>
        {
          c.order = tempOrder;
          tempOrder += 10;
        });

        updateStep[indexCondition].condition.push({
          processStep: _step._id,
          data: [],
          order: tempOrder
        });
      }
      
      //Check  Group
      //Check if Step is in the entry
      if (updateStep[indexUpdate].parentGroup){

        // let allLinkedStep = updateStep.filter(u => u.condition.findIndex(c => c.processStep == updateStep[indexUpdate]._id) > -1);

        // let sameGroupStep = updateStep.filter(s => s.parentGroup == updateStep[indexUpdate].parentGroup && s._id != updateStep[indexUpdate]._id );
        // let sameGroupGroup = toUpdateGroup.filter(g => g.parentGroup == updateStep[indexUpdate]._id);


        // allLinkedStep.forEach(a => {

        //   let groupIndex = toUpdateGroup.findIndex(g => g._id == updateStep[indexUpdate].parentGroup);

        //   if (toUpdateGroup[groupIndex].entry.findIndex(s => s.processStep == a._id) == -1)
        //   {

        //     //let newPosition = FindOpenPosition(300, 50, sameGroupStep.filter(s => s._id != a._id), sameGroupGroup, toUpdateGroup[groupIndex].entry);

        //     //updateStep[indexUpdate].position = newPosition

        //     if (a.parentGroup != toUpdateGroup[groupIndex]._id){

        //       let newPosition = FindOpenPosition(10, 50, sameGroupStep.filter(s => s._id != a._id), sameGroupGroup, toUpdateGroup[groupIndex].entry);


        //       toUpdateGroup[groupIndex].entry.push({
        //         processStep: a._id,
        //         position: newPosition
        //       });
        //     }


        //   }

        // });


      }else{


        if (!updateStep[indexUpdate].entry)
          updateStep[indexUpdate].parentGroup = currentGroup[currentGroup.length - 1]._id;

      }


      toUpdateGroup = verifyGroupEntry(updateStep, toUpdateGroup);


      setStep(updateStep);
      setGroup(toUpdateGroup);
      setNewCounter(newCounter => newCounter + 1);
      setChange(true);

    }catch(err){

      throw err;

    }

  };


  const OnConfirmComponent = (_data) => {

    try
    {

      let tempStep = _.cloneDeep(step);

      let updateEntrydex = tempStep.findIndex(s => s._id == _data.stepId);

      let updateComponentIndex = tempStep[updateEntrydex].component.findIndex(c => c._id == _data._id);

      //Check conditions formula to update text
      if (tempStep[updateEntrydex].component[updateComponentIndex].name != _data.data.name){

        for (let index = 0; index < tempStep.length; index++) {
          const currentStep = tempStep[index];

          for (let indexCondition = 0; indexCondition < currentStep.condition.length; indexCondition++) {
            const condition = currentStep.condition[indexCondition];
            
            for (let indexGroup = 0; indexGroup < condition.data.length; indexGroup++) {
              const group = condition.data[indexGroup];
              
              for (let indexLine = 0; indexLine < group.length; indexLine++) {
                const line = group[indexLine];

                ["valueLeft", "valueRight"].forEach(value => {

                  if (line[value].type == "formula"){
                    
                    let indexVariable = line[value].variable.findIndex(v => v.component == _data._id);

                    if (indexVariable > -1){

                      //Remplacer la variable dans la formule
                      tempStep[index].condition[indexCondition].data[indexGroup][indexLine][value].data = 
                        line[value].data.split("{" + tempStep[updateEntrydex].title + "." + tempStep[updateEntrydex].component[updateComponentIndex].name + "}")
                        .join("{" + tempStep[updateEntrydex].title + "." + _data.data.name + "}");

                    }

                  }

                });

                
              }
              
            }

            
          }

          
          
        }

      }



      tempStep[updateEntrydex].component[updateComponentIndex].name = _data.data.name;
      tempStep[updateEntrydex].component[updateComponentIndex].data = _data.data;


      setStep(tempStep);

      setChange(true);

    } catch (err)
    {

      throw err;

    }


  };

  const onMoveComponent = (_stepId, _componentId, _position) => {


    try{

      let tempStep = _.cloneDeep(step);

      let updateEntrydex = tempStep.findIndex(s => s._id == _stepId);

      let moveComponentIndex = tempStep[updateEntrydex].component.findIndex(c => c._id == _componentId);

      let newComponentIndex = moveComponentIndex + _position;

      //Can't move component outside of the array
      if (newComponentIndex <= -1 || newComponentIndex >= tempStep[updateEntrydex].component.length) return;

      //Remove current position and add it at new position
      tempStep[updateEntrydex].component.splice(newComponentIndex, 0, tempStep[updateEntrydex].component.splice(moveComponentIndex, 1)[0]);

      setStep(tempStep);
    
      setChange(true);

    } catch (err)
    {

      throw err;

    }



  };


  const onDeleteComponent = (_stepId, _componentId) => {

    try{

      let tempStep = _.cloneDeep(step);

      let updateEntrydex = tempStep.findIndex(s => s._id == _stepId);   

      tempStep[updateEntrydex].component = tempStep[updateEntrydex].component.filter(c => c._id != _componentId);

      setStep(tempStep);

      setChange(true);

    }catch(err){

      throw err;

    }

  };

  const onClickCondition = (_id, _processStep) => {

    setContext(context => ({ ...context, display: false }));

    setModalCondition({
      display: true,
      id: _id,
      processStep: _processStep
    });

  };

  const onConfirmCondition = (_condition) => {

    let tempStep = _.cloneDeep(step);

    let currentEntrydex = tempStep.findIndex(s => s._id == modalCondition.id);

    let currentConditionIndex = tempStep[currentEntrydex].condition.findIndex(c => c.processStep == modalCondition.processStep);


    if (currentEntrydex < 0 || currentConditionIndex < 0 ) throw new Error();


    tempStep[currentEntrydex].condition[currentConditionIndex] = _condition;


    setStep(tempStep);
    setChange(true);
  };

  const onClickConditionSort = (_id) =>
  {

    setContext(context => ({ ...context, display: false }));

    setModalConditionSort({
      display: true,
      id: _id
    });

  };
 
  const onClickSave = async() => {

    try {


      setLoading(true);

      //Keep current selected step index
      const currentIndex = step.findIndex(s => s._id == displayStep.id);


      let response = await processApi.updateProcessStep({
        process,
        step,
        group,
        variable
      });

      if (!response.Success)
      {
        let error = new Error()
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

        throw error;
      }

      await loadData(true, currentIndex);


      setLoading(false);
      setChange(false);


    }catch(err){

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });


    }

  };

  const onClickClose = () => {

    //If there is any change, ask to confirm before leaving
    if (change && !ReadOnly){
      setConfirm(confirm => ({
        Title: getLabel("App", "Close"),
        Message: getLabel("App", "Are you sure you want to close without saving"),
        Cancel: getLabel("App", "No"),
        onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
        Confirm: getLabel("App", "Yes"),
        onConfirm: onCloseModal,
        Display: true
      }));

    } else onCloseModal();


  };
  
  const onClickDeleteStep = (_step) => {

    setContext(context => ({
      ...context,
      display: false
    }));

    setConfirm({
      Title: getLabel("App", "Delete"),
      Message: getLabel(syscomponent, "Are you sure you want to delete this entity?") + ` [${_step.title}]`,
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: () => onDeleteStep(_step._id),
      Display: true
    });

  };

  const onDeleteStep = (_id) =>
  {

    try
    {


      setConfirm(confirm => ({ ...confirm, Display: false }));


      let stepToDelete = step.find(s => s._id == _id);

      //Verifiy if step is utilized in condition
      getPathFromStep(stepToDelete, step).forEach(s => {

        s.condition.forEach(c => {

          c.data.forEach(d => {

            d.forEach(g => {

              if (g.valueLeft.processStep == _id || g.valueRight.processStep == _id) throw new Error(getLabel("ProcessDesigner", "This step cannot be removed because it is utilized within a condition."));

            });

          });

        });

      });


      //Remove stepid in path
      let tempStep = _.cloneDeep(step);

      tempStep = tempStep.filter(s => s._id !== _id).map(s => {

        s.condition = s.condition.filter(c => c.processStep != _id).map(c => {

          return c;

        });



        return s;

      });

      let tempGroup = _.cloneDeep(group);


      tempGroup = verifyGroupEntry(tempStep, tempGroup);

      setStep(tempStep);
      setGroup(tempGroup);
      setChange(true);

    } catch (err)
    {

      throw new Error(err);

    };

  };

  const onUpdateDisplay = (_id) => {

    setContext(context => ({
      ...context,
      display: false
    }));


    if (_id){
      updateScrollPosition({
        x: parentContainer.current.scrollLeft,
        y: parentContainer.current.scrollTop
      });
    }




    setDisplayStep({
      detail: _id ? true : false,
      id: _id
    });

  };

  const onChangeView = () => {

    setFlowchart(flowchart => !flowchart);

  };

  const onClickSelectMultiple = (_id, _position = undefined) => {

    let currentScrollPosition = {
      x: parentContainer.current.scrollLeft,
      y: parentContainer.current.scrollTop
    };

    setCopy({
      enable: true,
      id: _id,
      data: [],
      position: addStep.position,
      parentGroup: currentGroup[currentGroup.length - 1]._id,
      currentGroup: currentGroup,
      scrollPosition: currentScrollPosition
    });



  };


  const onClickExternalCopy = (_id) => {


    setExternalCopy({
      enable: true,
      modal: true,
      id: _id,
      data: [],
      position: addStep.position,
      parentGroup: currentGroup[currentGroup.length - 1]._id
    });

  };

  const onClickSelectCopy = (_id) => {
    
    try{


      const findIndex = copy.data.findIndex(d => d == _id);

      if (findIndex > -1){

        setCopy(copy => ({
          ...copy,
          data: copy.data.filter(d => d != _id)
        }));

      }else{

        setCopy(copy => ({
          ...copy,
          data: [...copy.data, _id]
        }));

      }

      // if (findId > -1)
      // {

      //   let allSelectedStep = _.cloneDeep(step.filter(s => copy.data.findIndex(c => c == s._id) > -1 && s._id != _id));

      //   //Filter if the removed step was a parent
      //   allSelectedStep = allSelectedStep.filter(s => s.path.findIndex(p => p == _id) == -1);

      //   setCopy(copy => ({
      //     ...copy,
      //     data: allSelectedStep.map(s =>
      //     {
      //       return s._id
      //     })
      //   }));

      // } else
      // {

      //   let allSelectedStep = _.cloneDeep(step.filter(s => copy.data.findIndex(c => c == s._id) > -1 || s._id == _id));

      //   let toAddStep = [];


      //   if (allSelectedStep.length > 1)
      //   {

      //     let currentStep = _.cloneDeep(step.find(s => s._id == _id));

      //     allSelectedStep.forEach(s => {

      //       if (s._id == currentStep._id) return;

      //       //Special loop to select all paths
      //       LoopToLinkSelect(currentStep, s, allSelectedStep);


      //     });

      //   }

      //   allSelectedStep = [...allSelectedStep, ...toAddStep];


      //   setCopy(copy => ({
      //     ...copy,
      //     data: allSelectedStep.map(s =>
      //     {
      //       return s._id
      //     })
      //   }));

      // }

    }catch (err)
    {


      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: OnClose,
        Display: true
      });

    }


  }

  const onClickConfirmCopy = () => {

    if (IsExternalCopy) {
      OnConfirmExternalCopy(step.filter(s => copy.data.findIndex(c => c == s._id) > -1));
      setCopy({modal: false});
    }
    else setCopy((copy) => ({ ...copy, modal: true }));

  };

  const onCopySelected = (_step) => {
    

    try{


      let selectedStep = _.cloneDeep(_step);

      let currentTempId = tempId;
      let stepIdToReplace = [];
      let componentIdToReplace = [];

      let parentStep = step.find(s => s._id == copy.id && (!copy.parentGroup || s.parentGroup == copy.parentGroup));
      
      //Verify if the parent is an entry point
      group.some(g => {
        return g.entry.some(e => {
          if (e.processStep == copy.id && g._id == copy.parentGroup){
            parentStep = {
              _id: e.processStep,
              position: e.position
            };

            return true;
          }

          return false;

        });
      });

      let firstStep = selectedStep[0];

      let startPosition;



      if (parentStep) 
        startPosition = {
          x: parentStep.position.x + 300,
          y: parentStep.position.y,
        }
      else 
        startPosition = copy.position;


      let currentParentGroup = group.find(gr => gr._id == copy.parentGroup);

      startPosition = FindOpenPosition(startPosition.x, startPosition.y,
        step.filter(st => st.parentGroup == copy.parentGroup),
        group.filter(gr => gr.parentGroup == copy.parentGroup),
        (currentParentGroup ? currentParentGroup.entry : [])//currentGroup[conditionGroupIndex].entry
      );

      let positionMod = {
        x: 0,
        y: 0
      }


      for (const s of selectedStep)
      {


        //Never starting point
        s.isFirst = false;

        //Replace Id And Title of the step
        let currentReplace = {};
        currentReplace.prevId = s._id;
        currentReplace.prevTitle = s.prevTitle
        s._id = currentTempId;
        currentTempId--;
        currentReplace.id = s._id;
        currentReplace.title = s.title;

        stepIdToReplace.push(currentReplace);

        s.newCounter = newCounter + 1;

        //Replace Id and Name in component
        for (const c of s.component)
        {

          let currentReplace = {};
          currentReplace.prevId = c._id;
          c._id = currentTempId;
          currentTempId--;
          currentReplace.id = c._id;
          currentReplace.name = c.name;

          componentIdToReplace.push(currentReplace);


        };

        //Set the Parent Group
        // if (parentStep)
        //   s.parentGroup = parentStep.parentGroup;
        if (copy.parentGroup)
          s.parentGroup = copy.parentGroup;
        else
          s.parentGroup = undefined;

        //Set Process in case it's external
        s.process = process._id;

      };


      //Calculate the first Step position vs the parent
      positionMod.x = startPosition.x - firstStep.position.x;
      positionMod.y = startPosition.y - firstStep.position.y;
      
      for (const s of selectedStep)
      {

        //Update position
        s.position.x += positionMod.x + (parentStep ? 0 : 0);
        if (s.position.x > 10000) s.position.x = 10000;
        if (s.position.x < 0) s.position.x = 0;

        s.position.y += positionMod.y;
        if (s.position.y > 10000) s.position.y = 10000;
        if (s.position.y < 0) s.position.y = 0;

        //Replace id in condition
        for (let k = 0; k < s.condition.length; k++)
        {

          //Check for processStep
          let pathStepId = stepIdToReplace.find(sr => sr.prevId == s.condition[k].processStep);

          if (pathStepId)
            s.condition[k].processStep = pathStepId.id;
          else{
            s.condition.splice(k, 1);
            k--;
            continue;
          }


          //Replace id in condition
          for (let i = 0; i < s.condition[k].data.length; i++)
          {

            for (let j = 0; j < s.condition[k].data[i].length; j++)
            {

              let entryPath = true;
              let currentI = i;
              let currentJ = j;

              ["valueLeft", "valueRight"].forEach(property =>
              {

                if (s.condition[k].data[currentI][currentJ][property].processStep) 
                {

                  let foundCondStep = stepIdToReplace.find(st => st.prevId == s.condition[k].data[currentI][currentJ][property].processStep);
                
                  if (foundCondStep)
                  {
                    s.condition[k].data[currentI][currentJ][property].processStep = foundCondStep.id;
                    s.condition[k].data[currentI][currentJ][property].processStepTitle = foundCondStep.title;
                  } else
                  {
                    // if (s.path.findIndex(p => p == s.condition[k].data[currentI][currentJ][property].processStep) == -1)
                    entryPath = false;
                  }

                  if (s.condition[k].data[currentI][currentJ][property].component && entryPath)
                  {

                    let foundCondComp = componentIdToReplace.find(c => c.prevId == s.condition[k].data[currentI][currentJ][property].component);

                    if (foundCondComp)
                    {
                      s.condition[k].data[currentI][currentJ][property].component = foundCondComp.id;
                      s.condition[k].data[currentI][currentJ][property].componentName = foundCondComp.name;
                    }

                  }

                }
              });

              if (!entryPath)
              {
                s.condition[k].data[i].splice(j, 1);
                j--;
              }
            }

            if (s.condition[k].data[i].length == 0)
            {
              s.condition[k].data.splice(i, 1);
              i--;
            }

          }


        }


      };

      let toUpdateStep = _.cloneDeep(step);

      if (parentStep){

        //Find Parent
        let indexParent = toUpdateStep.findIndex(s => s._id == parentStep._id);

        // eslint-disable-next-line array-callback-return
        toUpdateStep[indexParent].condition.sort((a, b) =>
        {
          if (a.order >= b.order) return 1;
          if (a.order < b.order) return -1;
        });

        let tempOrder = 10;

        toUpdateStep[indexParent].condition.forEach(c =>
        {
          c.order = tempOrder;
          tempOrder += 10;
        });

        toUpdateStep[indexParent].condition.push({
          processStep: firstStep._id,
          data: [],
          order: tempOrder
        });

      };


      setStep([...toUpdateStep, ...selectedStep]);
      setChange(true);
      setTempId(currentTempId);

      //Set screen to parent position
      // updateScrollPosition({
      //   x: startPosition.x,
      //   y: startPosition.y
      // });

      updateScrollPosition({
        x: copy.scrollPosition ? copy.scrollPosition.x : startPosition.x,
        y: copy.scrollPosition ? copy.scrollPosition.y : startPosition.y
      }, copy.currentGroup);

      //Update group to show
      setCurrentGroup(copy.currentGroup);

      //Close copy modal
      setCopy({
        enable: false,
        modal: false,
        id: 0,
        data: []
      });
      setExternalCopy({
        enable: false,
        modal: false,
        id: 0,
        data: []
      });

      //Inc counter
      setNewCounter(newCounter => newCounter + 1);


    }catch (err)
    {
      console.log(err)

      throw new Error(getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."));

    }

  };

  const onConfirmCopyExternal = (_data) => {

    
    setExternalCopy(externalCopy => ({
      ...externalCopy,
      modal: false
    }));

    setCopy({
      modal: true,
      id: externalCopy.id,
      data: _data,
      parentGroup: currentGroup[currentGroup.length - 1]._id,
      position: addStep.position
    });

  }

  const onClickPublish = () =>
  {
    if (change){

      setConfirm(confirm => ({
        Title: getLabel(syscomponent, "Publish"),
        Message: getLabel(syscomponent, "Before publishing, please save your process. Would you like to save and proceed?"),
        Cancel: getLabel("App", "No"),
        onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
        Confirm: getLabel("App", "Yes"),
        onConfirm: onSaveAndOpenPublish,
        Display: true
      }));

    }else {
      setConfirm(confirm => ({ ...confirm, Display: false }));

      setPublish(true);
    }


    
  };

  const onSaveAndOpenPublish = async() => {

    try{

      setConfirm(confirm => ({ ...confirm, Display: false }));

      await onClickSave();

      setPublish(true);

    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });
    

    }

    

  }

  const onPublish = async(_id) => {

    try{


      let response = await processApi.publishProcess({
        _id: _id
      });

      if (!response.Success)
      {
        let error = new Error()
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

        throw error;
      }
      


    }catch(err){


      throw new Error(getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."));
      
    }

  };

  const onCloseModal = async() => {

    if (OnReloadData) OnReloadData();

    OnClose();

  };

  const onClickDesigner = (e) => {


    if (e.button == 0){
      if (context.display && !contextContainer.current.contains(e.target)){
        setContext(context => ({
          ...context,
          display: false
        }));
      }
    }
    else if (e.button === 2){

      if (context.display && !contextContainer.current.contains(e.target))
      {
        setContext(context => ({
          ...context,
          display: false
        }));
      }

      //Keep scroll position when first clicked
      rightClickPosition.current = {
        x: e.pageX,
        scrollX: parentContainer.current.scrollLeft,
        y: e.pageY,
        scrollY: parentContainer.current.scrollTop

      };
    



      
    }

  };

  const onClickMoreAddOption = (e) => {


    let currentOption = [
      { caption: getLabel("ProcessDesigner", "Add a new step"), onClick: onAddStep },
      { caption: getLabel("ProcessDesigner", "Add a new group"), onClick: onClickAddGroup }
      
    ];

    setContext({
      display: true,
      posX: e.pageX,
      posY: e.pageY,
      Option: currentOption
    });  
  };

  const onRightClickContext = (e) => {


    //If hold Ctrl key for PC or Meta for MAC, display default context
    if (!e.ctrlKey && !e.metaKey
        && !modalTest && !modalVariable && !modalCondition.display && !publish
        && !modalInit && !modalConditionSort.display 
        ){
      e.preventDefault();

      if (copy.enable) return;

      //If right click moved too much, don't open context
      if (Math.abs(rightClickPosition.current.scrollX - parentContainer.current.scrollLeft) +
        Math.abs(rightClickPosition.current.scrollY - parentContainer.current.scrollTop) > 10 ||
        (rightClickPosition.current.scrollX == parentContainer.current.scrollLeft &&
        rightClickPosition.current.scrollY == parentContainer.current.scrollTop &&
        Math.abs(rightClickPosition.current.x - e.pageX) + Math.abs(rightClickPosition.current.y - e.pageY) > 10))
        return;


      if (parentContainer.current.contains(e.target)){

        let currentPosition = {
          x: e.pageX - parentContainer.current.getBoundingClientRect().left + parentContainer.current.scrollLeft, 
          y: e.pageY - parentContainer.current.getBoundingClientRect().top + parentContainer.current.scrollTop
        }


        let currentOption = [
          { caption: getLabel("ProcessDesigner", "Add a new step"), onClick: () => onContextAddStep(undefined, [], currentPosition) },
          { caption: getLabel("ProcessDesigner", "Add a new group"), onClick: () => onClickAddGroup(currentPosition)}
        ];


        setContext({
          display: true,
          posX: e.pageX,
          posY: e.pageY,
          Option: currentOption
        });
      }




      
    }
      

  };

  const onRightClickContextStep = (e, _data) => {

    e.stopPropagation();

    //If hold Ctrl key for PC or Meta for MAC, display default context
    if (!e.ctrlKey && !e.metaKey)
    {
      e.preventDefault();

      if (copy.enable) return;

      //If right click moved too much, don't open context
      if (Math.abs(rightClickPosition.current.scrollX - parentContainer.current.scrollLeft) +
        Math.abs(rightClickPosition.current.scrollY - parentContainer.current.scrollTop) > 10 ||
        (rightClickPosition.current.scrollX == parentContainer.current.scrollLeft &&
          rightClickPosition.current.scrollY == parentContainer.current.scrollTop &&
          Math.abs(rightClickPosition.current.x - e.pageX) + Math.abs(rightClickPosition.current.y - e.pageY) > 10))
        return;


      if (parentContainer.current.contains(e.target))
      {

        let currentOption = [];

        //If Group
        if (_data.isGroup){

          currentOption = [
            { caption: getLabel("ProcessDesigner", "Open group"), onClick: () => onOpenGroup(_data) },
            { separator: "1px solid lightgrey", height: "5px" },
            { caption: getLabel("ProcessDesigner", "Edit group"), onClick: () => onEditGroup(_data) },
            { separator: "1px solid lightgrey", height: "5px" },
            { caption: getLabel("ProcessDesigner", "Delete this group"), onClick: () => onClickDeleteGroup(_data), disabled: !Access.canWrite || ReadOnly }
          ];
          //If Entry
        } else if (_data.entry)
        {

          currentOption = [
            { caption: getLabel("ProcessDesigner", "Edit step"), onClick: () => onUpdateDisplay(_data._id) },
            { separator: "1px solid lightgrey", height: "5px" },
            { caption: getLabel("ProcessDesigner", "Add a new step"), onClick: () => onClickDesigner(e), disabled: !Access.canWrite || ReadOnly },
            { separator: "1px solid lightgrey", height: "5px" },
            { caption: getLabel("ProcessDesigner", "Remove this entry point"), onClick: () => onClickDeleteEntry(_data), disabled: !Access.canWrite || ReadOnly }
          ];
        //If Step
        }else{

          currentOption = [
            { caption: getLabel("ProcessDesigner", "Edit step"), onClick: () => onUpdateDisplay(_data._id) },
            { caption: getLabel("ProcessDesigner", "Set as starting point"), onClick: () => onClickStartingPoint(_data), disabled: !Access.canWrite || ReadOnly || _data.isFirst },
            { caption: getLabel("ProcessDesigner", "Sort the conditions"), onClick: () => onClickConditionSort(_data._id), disabled: !Access.canWrite || ReadOnly || _data.condition.length < 2 },
            { separator: "1px solid lightgrey", height: "5px" },
            { caption: getLabel("ProcessDesigner", "Add a new step"), onClick: () => onAddStep(e, _data), disabled: !Access.canWrite || ReadOnly },
            { separator: "1px solid lightgrey", height: "5px" },
            { caption: getLabel("ProcessDesigner", "Delete this step"), onClick: () => onClickDeleteStep(_data), disabled: !Access.canWrite || ReadOnly }
          ];

        }


        setContext({
          display: true,
          posX: e.pageX,
          posY: e.pageY,
          Option: currentOption
        });
      }




      
    }
  };

  const onRightClickContextCondition = (e, _id, _processStep) =>
  {

    e.stopPropagation();

    //If hold Ctrl key for PC or Meta for MAC, display default context
    if (!e.ctrlKey && !e.metaKey)
    {
      e.preventDefault();

      if (copy.enable) return;

      //If right click moved too much, don't open context
      if (Math.abs(rightClickPosition.current.scrollX - parentContainer.current.scrollLeft) +
        Math.abs(rightClickPosition.current.scrollY - parentContainer.current.scrollTop) > 10 ||
        (rightClickPosition.current.scrollX == parentContainer.current.scrollLeft &&
          rightClickPosition.current.scrollY == parentContainer.current.scrollTop &&
          Math.abs(rightClickPosition.current.x - e.pageX) + Math.abs(rightClickPosition.current.y - e.pageY) > 10))
        return;


      if (parentContainer.current.contains(e.target))
      {
        let currentOption = [
          { caption: getLabel("ProcessDesigner", "Edit condition"), onClick: () => onClickCondition(_id, _processStep) },
          { separator: "1px solid lightgrey", height: "5px" },
          { caption: getLabel("ProcessDesigner", "Delete this condition"), onClick: () => onClickDeleteCondition(_id, _processStep), disabled: !Access.canWrite || ReadOnly },
          // { separator: "1px solid lightgrey", height: "5px" },
          // { caption: getLabel("ProcessDesigner", "Delete this step"), onClick: () => onClickDeleteStep(_data), disabled: !Access.canWrite || ReadOnly }
        ];

        setContext({
          display: true,
          posX: e.pageX,
          posY: e.pageY,
          Option: currentOption
        });
      }





    }
  };

  const onContextAddStep = (_parentId, _parentPath, _position = {x: 0, y: 0}) => {

    let currentScrollPosition = {
      x: parentContainer.current.scrollLeft,
      y: parentContainer.current.scrollTop
    };

    setAddStep({ display: true, parentId: _parentId, parentPath: _parentPath, position: _position, scrollPosition: currentScrollPosition  });

    setContext(context => ({...context, display: false}));

  };

  const onClickStartingPoint = (_step) => {


    setContext(context => ({
      ...context,
      display: false
    }));

    try{

      let updateStep = _.cloneDeep(step);

      updateStep = updateStep.map(s => {
        if (s._id == _step._id){
          return {
            ...s,
            isFirst: true
          };
        }else{
          return {
            ...s,
            isFirst: false
          };        
        }
      });


      //let isFirststep = updateStep.findIndex(s => s._id == _step._id);


      // let hasParent = updateStep.some(s => {
      //   return s.condition.some(c => c.processStep == updateStep[isFirststep]._id);
      // });

      // let noLongerFirststep = updateStep.findIndex(s => s.isFirst);

      // updateStep[isFirststep].isFirst = true;
      // updateStep[noLongerFirststep].isFirst = false;

      setStep(updateStep);
      setChange(true);



    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: OnClose,
        Display: true
      });

    };




  };

  const onAddStep = (e, _data = undefined) => {

    //Close context if open
    setContext({display: false, posX: 0, posY: 0, Option: []});

    let currentPosition = {
      x: 0,
      y: 0
    };

    //If not the first step, position in the center of the screen
    if (step.length > 0){
      currentPosition = {
        x: parentContainer.current.scrollLeft + (parentContainer.current.getBoundingClientRect().width / 2) - 80,
        y: parentContainer.current.scrollTop + (parentContainer.current.getBoundingClientRect().height / 2) - 50,
      };

      if (currentPosition.x < 0) currentPosition.x = 0;
      if (currentPosition.y < 0) currentPosition.y = 0;
    }

    let currentScrollPosition = {
      x: parentContainer.current.scrollLeft,
      y: parentContainer.current.scrollTop
    };    


    setAddStep({
      display: true,
      parentId: _data ? _data._id : undefined,
      parentPath: [],
      position: currentPosition,
      scrollPosition: currentScrollPosition
    });

  };

  const onEditGroup = (_data) => {

    //Close context if open
    setContext({ display: false, posX: 0, posY: 0, Option: [] });


    setModalGroup({ display: true, data: _data, position: undefined }) 

  };

  const onClickAddGroup = (_position) => {

    //Close context if open
    setContext({ display: false, posX: 0, posY: 0, Option: [] });

    if (!_position){
      _position = {
        x: parentContainer.current.scrollLeft + (parentContainer.current.getBoundingClientRect().width / 2) - 80,
        y: parentContainer.current.scrollTop + (parentContainer.current.getBoundingClientRect().height / 2) - 50,
      };     
    }

    setModalGroup({ display: true, data: undefined, position: _position, parentGroup: currentGroup[currentGroup.length - 1]._id }) 

  };

  const onAddGroup = (_group) => {
    try
    {

      let updateGroup = _.cloneDeep(group);

      let indexUpdate = updateGroup.findIndex(g => g._id === _group._id);

      if (indexUpdate > -1)
      {

        updateGroup[indexUpdate] = _group;

      } else
      {

        _group.newCounter = newCounter + 1;
        updateGroup.push(_group);
      }


      setGroup(updateGroup);
      setTempId(tempId => tempId - 1);
      setNewCounter(newCounter => newCounter + 1);
      setChange(true);


    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }


  };

  const onOpenGroup = (_group) => {

    //Close context if open
    setContext({ display: false, posX: 0, posY: 0, Option: [] });

    updateScrollPosition({
      x: parentContainer.current.scrollLeft,
      y: parentContainer.current.scrollTop
    });

    setCurrentGroup(currentGroup => [...currentGroup, _group]);



  };

  const addCondition = (_from, _to) => {



  };

  const onClickDeleteCondition = (_id, _processStep) =>
  {

    setContext(context => ({
      ...context,
      display: false
    }));

    setConfirm({
      Title: getLabel("App", "Delete"),
      Message: getLabel(syscomponent, "Are you sure you want to delete this condition?"),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: () => onDeleteCondition(_id, _processStep),
      Display: true
    });

  };

  const onDeleteCondition = (_id, _processStep) =>
  {

    try
    {

      let updateStep = _.cloneDeep(step);

      let indexStep = updateStep.findIndex(s => s._id == _id);

      let indexCondition = updateStep[indexStep].condition.findIndex(c => c.processStep == _processStep);


      updateStep[indexStep].condition.splice(indexCondition, 1);

      setStep(updateStep);
      setChange(true);

      setConfirm(confirm => ({ ...confirm, Display: false }));

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: OnClose,
        Display: true
      });

    };

  }

  const onClickDeleteGroup = (_group) =>
  {

    setContext(context => ({
      ...context,
      display: false
    }));

    setConfirm({
      Title: getLabel("App", "Delete"),
      Message: getLabel(syscomponent, "Are you sure you want to delete this entity?") + ` [${_group.title}]`,
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: () => onDeleteGroup(_group._id),
      Display: true
    });

  };

  const onDeleteGroup = (_id) =>
  {

    try
    {


      setConfirm(confirm => ({ ...confirm, Display: false }));


      let indexGroupToDelete = group.findIndex(g => g._id == _id);

      
      if (step.findIndex(s => s.parentGroup == group[indexGroupToDelete]._id) > -1 
        || group.findIndex(g => g.parentGroup == group[indexGroupToDelete]._id) > -1){

        throw new Error(getLabel("ProcessDesigner", "This group cannot be deleted as it must be empty."));
      }


      setGroup(group => group.filter(g => g._id != _id));
      setChange(true);

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    };

  };

  const onClickDeleteEntry= (_entry) =>
  {

    setContext(context => ({
      ...context,
      display: false
    }));

    setConfirm({
      Title: getLabel("App", "Delete"),
      Message: getLabel(syscomponent, "Are you sure you want to delete this entity?") + ` [${_entry.title}]`,
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: () => onDeleteEntry(_entry),
      Display: true
    });

  };

  const onDeleteEntry = (_entry) =>
  {

    try
    {



      setConfirm(confirm => ({ ...confirm, Display: false }));

      let toUpdateStep = _.cloneDeep(step);
      let toUpdateGroup = _.cloneDeep(group);

      let entryToDelete = [
         _entry.group._id
      ];

      let currentGroup = _entry.group._id;

      entryToDelete = loopDeleteEntry(_entry, currentGroup, entryToDelete);

      let indexStep = toUpdateStep.findIndex(s => s._id == _entry._id);


      //Delete condition using the Entry
      for (let i = 0; i < toUpdateStep[indexStep].condition.length; i++)
      {

        let condStep = toUpdateStep.find(s => s._id == toUpdateStep[indexStep].condition[i].processStep);

        if (entryToDelete.findIndex(d => d == condStep.parentGroup) > -1){
          toUpdateStep[indexStep].condition.splice(i, 1);
        };

      }


      //Delete the Entry
      for (let i = 0; i < toUpdateGroup.length; i++)
      {

        if (entryToDelete.findIndex(d => d == toUpdateGroup[i]._id) > -1){
          
          let indexToDelete = toUpdateGroup[i].entry.findIndex(e => e.processStep == _entry._id)

          if (indexToDelete > -1){
            toUpdateGroup[i].entry.splice(indexToDelete, 1);
          }

        }

      }

      

      setStep(toUpdateStep);
      setGroup(toUpdateGroup);
      setChange(true);

    } catch (err)
    {


      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    };

  };

  const loopDeleteEntry = (_entry, _currentGroup, _toDeleteEntry) => {

    group.forEach(g => {

      if (g.parentGroup == _currentGroup){

        g.entry.forEach(e => {

          if (e.processStep == _entry._id){
            
            if (_toDeleteEntry.findIndex(d => d == g._id) == -1) {
              
              _toDeleteEntry.push(g._id);

            }

            loopDeleteEntry(_entry, g._id, _toDeleteEntry);

          }

        });

      }

    });

    return _toDeleteEntry;

  };

  const onConfirmInit = (_init) => {

    try{

      _init.script.forEach(s => s.display = false);

      setProcess(process => ({
        ...process,
        initScript: _init
      }));
    
      setChange(true);

      setModalInit(false);

    } catch (err)
    {


      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    };

  };

  const onConfirmVariable = (_data) =>
  {

    try
    {


      setVariable(_data);

      setChange(true);

    } catch (err)
    {



    };

  };



  return (
    <div className="page_modal_background" onContextMenu={IsDesktop ? onRightClickContext : undefined} onMouseDown={IsDesktop ? onClickDesigner : undefined}>
      <div className="processdesigner_modal_cont" >
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        {copy.enable ? (
          <div className="processdesigner_header_cont_v2" style={{minHeight: "80px"}}>
            <div className="processdesigner_header_row" style={{ width: "100%" }}>
              <div className="processdesigner_header_title" style={{fontSize: "110%"}}>
                {getLabel("ProcessDesigner", "Select Steps")}
              </div>
              <div className="processdesigner_header_title" style={{ fontSize: "90%", color: "#231f20", marginTop: "5px" }}>
                {getLabel("ProcessDesigner", "Please select every step that you wish...")}
              </div>
            </div>
            {!displayStep.detail &&
              <div className="processdesigner_header_row" style={{ width: "100%", marginTop: "10px" }}>

                <ProcessDesignerNavigation
                  CurrentGroup={currentGroup}
                  SetCurrentGroup={setCurrentGroup}
                />
              </div>
            }
          </div>
        ):(
            <div className="processdesigner_header_cont_v2">
              <div className="processdesigner_header_row" style={{ width: "100%" }}>
                <div className="processdesigner_header_col" style={{ width: "100%" }}>
                  <div className="processdesigner_header_title_v2">
                    {getLabel("App", "Process Designer")} : {Title}
                  </div>
                </div>
              </div>
              <div className="page_action_cont" style={{ width: "100%" }}>
                <div className="page_action_section" style={{width: "30%"}}>
                  {!displayStep.detail &&
                  <ActionButton
                    IsDesktop={false}
                    Label={getLabel("ProcessDesignerItem", "Add Step")}
                    Icon={MdAdd}
                    Disabled={loading}
                    OnClick={(loading) ? undefined : onAddStep}
                    buttonStyle={{ width: "46px", height: "46px", borderTopRightRadius: "0px", borderBottomRightRadius:  "0px", marginRight: "0px" }}
                    iconStyle={{marginRight: "0px"}}
                  />
                  }  
                  {!displayStep.detail &&
                    <ActionButton
                      IsDesktop={false}
                      Label={getLabel("ProcessDesigner", "More options")}
                      Icon={MdArrowDropDown}
                      Disabled={loading}
                      OnClick={(loading) ? undefined : onClickMoreAddOption}
                      buttonStyle={{ width: "30px", height: "46px", borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px", marginLeft: "0px" }}
                      iconStyle={{marginRight: "0px"}}
                    />
                  }  
                </div>
                <div className="page_action_section" style={{ width: "38%", justifyContent: "center" }}>
                  <ActionButton
                    IsDesktop={false}
                    Label={getLabel("ProcessDesigner", "Test this process")}
                    Icon={TbPlayerPlayFilled}
                    Disabled={loading}
                    OnClick={(loading) ? undefined : onClickTest}
                    buttonStyle={{ width: "46px", height: "46px" }}
                  />  
                </div>
                <div className="page_action_section" style={{ width: "30%", justifyContent: "flex-end" }}>
                  <ActionButton
                    IsDesktop={false}
                    Label={getLabel("VariableDesigner", "Variable Designer")}
                    Icon={TbVariable}
                    Disabled={loading}
                    OnClick={(loading) ? undefined : onClickVariableDesigner}
                    buttonStyle={{ width: "46px", height: "46px" }}
                  /> 
                  <ActionButton
                    IsDesktop={false}
                    Label={getLabel("InitDesigner", "Initialization script designer")}
                    Icon={MdCode}
                    Disabled={loading}
                    OnClick={(loading) ? undefined : () => setModalInit(true)}
                    buttonStyle={{ width: "46px", height: "46px" }}
                  /> 
                </div>
              </div>
              {!displayStep.detail &&
                <div className="processdesigner_header_row" style={{ width: "100%" }}>

                  <ProcessDesignerNavigation
                    CurrentGroup={currentGroup}
                    SetCurrentGroup={setCurrentGroup}
                  />
                </div>
              }
          </div>
        )}

        <div className="processdesigner_body_cont" ref={parentContainer} {...events} > 
          <ContextMenu
            currentRef={contextContainer}
            data={context}
            width={200}
            onCloseMenu={() => setContext(context => ({ ...context, display: false }))}
          />
          {externalCopy.modal && 
            <ProcessDesignerCopyExternal
              Process={process}
              OnCloseModal={() => setExternalCopy(externalCopy => ({...externalCopy, modal: false, enable: false}))}
              OnConfirm={onConfirmCopyExternal}
            />
          }
          {modalGroup.display &&
            <ProcessDesignerGroup 
              Data={modalGroup.data}
              Group={group}
              TempId={tempId}
              SetTempId={setTempId}
              Position={modalGroup.position}
              Access={Access}
              ReadOnly={ReadOnly || copy.enable}
              Process={process}
              ParentGroup={modalGroup.parentGroup}
              OnCloseModal={() => setModalGroup({ display: false, data: undefined, position: undefined})}
              OnAddGroup={onAddGroup}
            />
          }
          {modalTest &&
            <ProcessDesignerTest
              IsDesktop={IsDesktop}
              Process={{_id: ProcessId }}
              InitScript={process.initScript}
              Step={step}
              Variable={variable}
              OnCloseModal={() => setModalTest(false)}
            />
          }
          {modalVariable &&
            <VariableDesigner 
              IsDesktop={IsDesktop}
              Access={Access}
              ReadOnly={ReadOnly}
              OnCloseModal={onClickVariableDesigner}
              Variable={variable}
              VariableType={variableType}
              ProcessId={ProcessId}
              InitScript={process.initScript}
              Step={step}
              LoadData={loadVariable}
              OnConfirm={onConfirmVariable}
              TempId={tempId}
              SetTempId={setTempId}
            />
          }
          {modalCondition.display && 
            <ConditionDesigner
              IsDesktop={IsDesktop}
              Access={Access}
              ReadOnly={ReadOnly || copy.enable}
              OnCloseModal={() => setModalCondition({display: false, id: 0})}
              Variable={variable}
              Step={step}
              CurrentStep={step.find(s => s._id == modalCondition.id)}
              ConditionProcessStep={modalCondition.processStep}
              OnConfirm={onConfirmCondition}
            />
          }
          {modalConditionSort.display &&
            <ConditionDesignerSort
              IsDesktop={IsDesktop}
              OnCloseModal={() => setModalConditionSort({ display: false, id: 0 })}
              OnConfirm={onUpdateStep}
              Step={step}
              CurrentStep={step.find(s => s._id == modalConditionSort.id)}
              ConditionProcessStep={modalConditionSort.processStep}
            />
          }
          {copy.modal && 
            <ProcessDesignerCopy
              IsDesktop={IsDesktop}
              Access={Access}
              ReadOnly={ReadOnly}
              Data={externalCopy.enable ? copy.data : step.filter(s => copy.data.findIndex(c => c == s._id) > -1)}
              Step={step}
              OnConfirm={onCopySelected}
              OnCloseModal={() => setCopy((copy) => ({...copy, modal: false  }))}
            />
          }
          {modalInit &&
            <InitDesigner
              IsDesktop={IsDesktop}
              Access={Access}
              ReadOnly={ReadOnly}
              Data={process.initScript}
              Variable={variable}
              Step={step}
              OnCloseModal={() => setModalInit(false)}
              OnConfirm={onConfirmInit}
            />
          }
          {publish && 
            <AdminProcessPublish
              IsDesktop={IsDesktop}
              Access={Access}
              ReadOnly={ReadOnly}
              Process={process}
              Publish={process.publish}
              Change={change}
              OnCloseModal={() => setPublish(false)}
              OnPublish={onPublish}
            />
          }
          <ProcessDesignerSchema 
            IsDesktop={IsDesktop}
            Access={Access}
            ReadOnly={ReadOnly}
            Process={process}
            Step={step}
            StepTemplate={stepTemplate}
            TempId={tempId}
            SetTempId={setTempId}
            Component={component}
            ComponentAction={componentAction}
            OnClickSave={onClickSave}
            OnUpdateStep={onUpdateStep}
            OnConfirmComponent={OnConfirmComponent}
            OnDeleteComponent={onDeleteComponent}
            OnMoveComponent={onMoveComponent}
            OnClickCondition={onClickCondition}
            OnDeleteStep={onDeleteStep}
            DisplayStep={displayStep}
            OnUpdateDisplay={onUpdateDisplay}
            Flowchart={flowchart}
            OnChangeView={onChangeView}
            OnClickSelectMultiple={onClickSelectMultiple}
            CopyMode={copy.enable}
            CopyData={copy.data}
            OnClickSelectCopy={onClickSelectCopy}
            NewCounter={newCounter}
            OnRightClickContextStep={onRightClickContextStep}
            OnRightClickContextCondition={onRightClickContextCondition}
            AddStep={addStep}
            ParentContainer={parentContainer}
            AddCondition={addCondition}
            CurrentGroup={currentGroup}
            SetCurrentGroup={setCurrentGroup}
            Group={group}
            OnUpdateGroup={onAddGroup}
            OnOpenGroup={onOpenGroup}
            OnClickExternalCopy={onClickExternalCopy}
          />
        </div>
        {copy.enable ? (
          <div className="processdesigner_footer_cont" style={{flexDirection: "column"}}>
            <div className="processdesigner_header_col" style={{ width: "100%" }}>
              <div className="processdesigner_selected_info">
                {getLabel("ProcessDesigner", "Selected Steps")} : {copy.data.length}
              </div>
            </div>
            <div className="processdesigner_header_col" style={{ width: "100%" }}>
              <input
                type="button"
                className="page_button page_modal_footer_button"
                value={getLabel("App", "Cancel")}
                style={{ backgroundColor: "grey", maxWidth: "200px" }}
                onClick={(loading) ? undefined : () => setCopy({enable: false, id: 0, data: []})}
                disabled={loading}
              />
              <input
                type="button"
                className="page_button page_modal_footer_button"
                value={getLabel("App", "Confirm")}
                style={{ maxWidth: "200px" }}
                onClick={(loading) ? undefined : onClickConfirmCopy}
                disabled={loading}
              />
            </div>
          </div>      
        ):(
        <div className="processdesigner_footer_cont">
          <div className="processdesigner_header_col" style={{ width: (IsDesktop ? "35%" : "100%") }}>
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App", "Close")}
              style={{ backgroundColor: "grey", maxWidth: "200px" }}
              onClick={(loading) ? undefined : onClickClose}
              disabled={loading}
            />
            {(Access.canWrite && !ReadOnly) && 
              <input
                type="button"
                className="page_button page_modal_footer_button"
                value={getLabel("App", "Save") + (change ? " *" : "")}
                style={{ maxWidth: "200px" }}
                onClick={(loading) ? undefined : onClickSave}
                disabled={loading}
              />
            }
            {(Access.canWrite && !ReadOnly) && 
              <input
                type="button"
                className="page_button page_modal_footer_button"
                value={getLabel(syscomponent, "Publish")}
                style={{ maxWidth: "200px", backgroundColor: "#5ba644" }}
                  onClick={(loading) ? undefined : onClickPublish}
                disabled={loading}
              />
            }
          </div>
        </div>
       )}
      </div>
    </div>
  )

};


export default ProcessDesigner;